import { ForwardedRef, forwardRef, ReactNode } from "react";
import {
  Collapse,
  Flex,
  List,
  ListItem,
  ListItemProps,
} from "@chakra-ui/react";

type Props = ListItemProps & {
  children: ReactNode;
  isCurrent?: boolean;
  subLinks?: ReactNode;
};

function SideBarLinkItem(
  { children, isCurrent, subLinks, ...rest }: Props,
  ref: ForwardedRef<HTMLLIElement>,
) {
  return (
    <ListItem ref={ref} {...rest}>
      <Flex display="block">{children}</Flex>
      {subLinks && (
        <Collapse in={!!isCurrent} unmountOnExit>
          <List pt={2} pb={4}>
            {subLinks}
          </List>
        </Collapse>
      )}
    </ListItem>
  );
}

export default forwardRef(SideBarLinkItem);
